import store from '../store'
import { getSubCount, getSubCountN, NOT_SET } from "./accountSubscription"

export const EMAIL_VERIF_PERIOD = 600000 // 10 min

// ACCOUNT STATE
export const AS = {
  DEMO: 'DEMO',
  DEMO_OC: 'DEMO_OC',
  WAITTING_D: 'WAITTING_D',
  WAITTING_D_OC: 'WAITTING_D_OC',
  WAITTING_F: 'WAITTING_F',
  WAITTING_F_OC: 'WAITTING_F_OC',
  WAITTING_F_OD: 'WAITTING_F_OD',
  FULL: 'FULL',
  FULL_OC: 'FULL_OC',
  FULL_OD: 'FULL_OD'
}

const txt = {
  ZV: 'ZKUŠEBNÍ VERZE',
  OV: 'OMEZENÁ VERZE',
  PV: 'PLNÁ VERZE',
  OaPV: '$Objednána plná verze',
  VPPVZV: '#Vyčerpán počet parcel ve zkušební verzi',
  PN: '#Platba neuhrazena',
  VPPP: '#Vyčerpán předplacený počet parcel',
  PDPP: '#Překročena doba platnosti předplatného',
  OtPV: 'Objednat plnou verzi',
  OP: 'Obnovit předplatné',
  NP: 'Navýšit předplatné',
  SO: '#Stav objednávky'
}

// ACCOUNT STATE DESCRIPTONS  [ [LABELS OR ALERTS ] OFFER ]
export const ASD = {
  DEMO: [[txt.ZV], txt.OtPV],
  DEMO_OC: [[txt.OV, txt.VPPVZV], txt.OtPV],
  WAITTING_D: [[txt.ZV, txt.OaPV, txt.PN], txt.SO],
  WAITTING_D_OC: [[txt.OV, txt.VPPVZV, txt.OaPV, txt.PN], txt.SO],
  WAITTING_F: [[txt.PV, txt.OaPV, txt.PN], txt.SO],
  WAITTING_F_OC: [[txt.OV, txt.VPPP, txt.OaPV, txt.PN], txt.SO],
  WAITTING_F_OD: [[txt.OV, txt.PDPP, txt.OaPV, txt.PN], txt.SO],
  FULL: [[txt.PV], txt.NP],
  FULL_OC: [[txt.OV, txt.VPPP], txt.OP],
  FULL_OD: [[txt.OV, txt.PDPP], txt.OP]
}

const MAX_DEMO = 10

export const getMaxCount = (subscription, as, asString = true, prevSubscription) => {
  if (subscription === NOT_SET) {
    return MAX_DEMO
  }
  let s = subscription
  switch (as) {
    case AS.WAITTING_D:
    case AS.WAITTING_D_OC:
      return MAX_DEMO
    case AS.WAITTING_F:
    case AS.WAITTING_F_OC:
    case AS.WAITTING_F_OD:
      s = prevSubscription
      break
    default:
  }
  return asString ? getSubCount(s) : getSubCountN(s)
}

export const allowImport = (as) => {
  switch (as) {
    case AS.FULL:
    case AS.WAITTING_F:
      return true      
    default:
      return false
  }
}

// 1. START: receive AS, if AS.FULL or AS.WAITTING_F then check date 
export const checkExpDate = (as, d, o) => {
  const same = {
    as: as,
    o: o
  }
  if (as === AS.FULL || as === AS.WAITTING_F) {
    if (new Date() <= new Date(d)) {
      return same
    }
    return {
      as: as === AS.FULL ? AS.FULL_OD : AS.WAITTING_F_OD,
      o: true
    }
  }
  return same
}

// 2. ADD PARCEL:  if AS.DEMO or AS.WAITTING_D or AS.FULL or AS.WAITTING_F then check count 
export const checkCount = (c) => {
  const { as, o, regData } = store.getState().account
  const same = {
    as: as,
    o: o
  }
  if (as === AS.DEMO || as === AS.FULL || as === AS.WAITTING_D || as === AS.WAITTING_F ) {
    const { subscription, prevSubscription } = regData
    if (c < getMaxCount(subscription, as, false, prevSubscription)) {
      return same
    }
    let cas
    switch (as) {
      case AS.DEMO:
        cas = AS.DEMO_OC
        break
      case AS.FULL:
        cas = AS.FULL_OC
        break
      case AS.WAITTING_D:
        cas = AS.WAITTING_D_OC
        break
      case AS.WAITTING_F:
        cas = AS.WAITTING_F_OC
        break
      default:
        break
    }
    return {
      as: cas,
      o: true
    }
  }
  return same
}

//  3. ORDER:
export const resolveOrder = (as) => {
  switch (as) {
    case AS.DEMO:
      return AS.WAITTING_D
    case AS.DEMO_OC:
      return AS.WAITTING_D_OC
    case AS.FULL:
      return AS.WAITTING_F
    case AS.FULL_OC:
      return AS.WAITTING_F_OC
    case AS.FULL_OD:
      return AS.WAITTING_F_OD
    default:
      return as
  }
}

export const checkCountForImport = (countOfImported) => {
  const state = store.getState()
  const { as, c, regData } = state.account
  const res = c + countOfImported 
  return {
    over: res >= getMaxCount(regData.subscription, as, false),
    userId: state.authState.uid,
    newCount: res
  }
}


// WEBPACK FOOTER //
// ./src/config/account.js